import React, { useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';

interface DatePickerProps {
  readonly?: boolean;
  label?: string;
  value: string | null;
  onChange: (date: string) => void;
  id?: string;
  adminDate?: boolean;
  iconGreenNone?: boolean;
  minDate?: Date;
  maxDate?: Date;
  dateFormat?: string;
  isClearable?: boolean;
}

const DatePickerComponent: React.FC<DatePickerProps> = ({
  readonly = false,
  label,
  value,
  onChange,
  id = "",
  adminDate = false,
  iconGreenNone = false,
  minDate = new Date(1900, 0, 1), // Default: January 1, 1900
  maxDate = new Date(2099, 11, 31), // Default: December 31, 2099
  dateFormat = "dd-MM-yyyy", // Default format
  isClearable = true,
}) => {
  const handleDateChange = (date: Date | null) => {
    const formattedDate = date ? `${moment(date).format("YYYY-MM-DD")}T00:00:00Z` : ""; // Handle null case
    onChange(formattedDate); // Return the formatted date or an empty string if cleared
  };

  // Ensure that selectedDate is a valid Date object
  let [year, month, day] = value?.split("T")[0].split("-") || [];
  const selectedDate = value ? new Date(parseInt(year), parseInt(month) - 1, parseInt(day)) : null;
  const datePickerRef = useRef<any>(null);

  return (
    <div className="date-picker-container">
      {label && (
        <label
          className={`${adminDate
              ? "font-Poppins-Regular font-size-18px"
              : "text-white font-Poppins-Medium font-size-16px"
            }`}
        >
          {label}
        </label>
      )}
      <div className="date-picker-input-container">
        <DatePicker
          ref={datePickerRef} 
          readOnly={readonly}
          id={id}
          selected={selectedDate} // Selected date is a native JavaScript Date object
          onChange={(date: Date | null) => handleDateChange(date)} // Handle both date and null
          dateFormat={dateFormat} // Dynamic display format
          placeholderText={dateFormat.replace(/-/g, "/").toUpperCase()} // Placeholder based on format
          className="date-picker-input"
          onKeyDown={(e) => e.preventDefault()} // Disable manual typing
          showYearDropdown
          scrollableYearDropdown
          yearDropdownItemNumber={50}
          minDate={minDate} // External configuration
          maxDate={maxDate} // External configuration
          isClearable={isClearable} // External configuration
        />
        {!selectedDate && (
          <FontAwesomeIcon
            icon={faCalendarAlt}
            onClick={() => datePickerRef.current?.setOpen(true)} // Add this line to open the calendar

            className={`calendar-icon ${iconGreenNone
                ? "text-[#232323] font-size-16px"
                : "theme-color-green font-size-18px"
              }`}
          />
        )}
      </div>
    </div>
  );
};

export default DatePickerComponent;